(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  /* header dropdowns: tap to open on touch */
  $$('.l8nav__item.has-sub > button, .l8region__btn').forEach(function(b){
    b.addEventListener('click',function(e){
      var p=b.parentElement,open=p.classList.contains('is-open');
      $$('.l8header .is-open').forEach(function(n){n.classList.remove('is-open');var x=$('button',n);x&&x.setAttribute('aria-expanded','false')});
      if(!open){p.classList.add('is-open');b.setAttribute('aria-expanded','true')}
      e.stopPropagation();
    });
  });
  document.addEventListener('click',function(){$$('.l8header .is-open').forEach(function(n){n.classList.remove('is-open')})});
  /* track picker */
  var tracks=$$('[data-track]'),panels=$$('[data-track-panel]');
  var grid=$('.track-grid'),cont=grid&&grid.parentElement;
  function place(key){
    var p=$('[data-track-panel="'+key+'"]');if(!p||!grid)return;
    if(window.matchMedia('(max-width:989px)').matches){
      var cards=$$('.track',grid),i=0;
      cards.forEach(function(c,n){if(c.getAttribute('data-track')===key)i=n});
      var end=Math.min(i%2===0?i+1:i,cards.length-1);
      cards[end].insertAdjacentElement('afterend',p);
    }else{cont.appendChild(p)}
  }
  function openTrack(key,scroll){
    if(key)place(key);
    tracks.forEach(function(t){t.setAttribute('aria-expanded',t.getAttribute('data-track')===key?'true':'false')});
    panels.forEach(function(p){p.hidden=p.getAttribute('data-track-panel')!==key});
    $$('[data-tbanner-video]').forEach(function(v){var open=v.closest('[data-track-panel]')&&!v.closest('[data-track-panel]').hidden;if(open){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){})}else{v.pause()}});
    if(scroll){var p=$('[data-track-panel="'+key+'"]');if(p){setTimeout(function(){p.scrollIntoView({behavior:'smooth',block:'start'})},60)}}
  }
  tracks.forEach(function(t){t.addEventListener('click',function(){
    var k=t.getAttribute('data-track');
    if(t.getAttribute('aria-expanded')==='true'){openTrack(null)}else{openTrack(k,true)}
  })});
  $$('[data-track-close]').forEach(function(b){b.addEventListener('click',function(){openTrack(null);var s=$('#tracks');s&&s.scrollIntoView({behavior:'smooth'})})});
  /* jump cards that should open a track */
  $$('[data-open-track]').forEach(function(a){a.addEventListener('click',function(e){
    var k=a.getAttribute('data-open-track');
    var mobile=window.matchMedia('(max-width:989px)').matches;
    if(mobile){e.preventDefault();openTrack(k,true)}else{setTimeout(function(){openTrack(k,false)},50)}
  })});
  if(location.hash){var m=location.hash.match(/^#track-(.+)$/);if(m)openTrack(m[1],true)}
  /* banner videos on collection pages: play when visible */
  var cv=$$('.collection [data-tbanner-video]');
  if(cv.length&&'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var pr=v.play();if(pr&&pr.catch)pr.catch(function(){})}else{v.pause()}})},{threshold:.25});
    cv.forEach(function(v){v.preload='metadata';io.observe(v)});
  }
  var mm=$('#MobileMenu .mobile-menu__panel');
  if(mm&&!$('.mobile-menu__close',mm)){
    var cb=document.createElement('button');cb.type='button';cb.className='mobile-menu__close';cb.setAttribute('aria-label','Close menu');cb.innerHTML='&times;';
    cb.addEventListener('click',function(){var t=$('[data-menu-toggle]');t&&t.click()});
    mm.insertBefore(cb,mm.firstChild);
  }
})();